import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

import { useEffect, useRef, useState } from 'react';
import { DatePickerProps } from 'react-date-picker';
import { FormattedMessage } from 'react-intl';

import useOuterClick from '../../hooks/useOuterClick';
import Button from '../Button/Button';
import {
  CalendarContainerStyled,
  DatePickerStyled,
  DatePickerWrapperStyled,
} from './DatePickerField.styled';

const DATE_FORMAT = 'dd/MM/y';
const DEFAULT_LOCALE = 'en-EN';

type DatePickerFieldPropsT = Omit<DatePickerProps, 'onChange'> & {
  onChange: (val: Date) => void;
};

const DatePickerField: React.FC<DatePickerFieldPropsT> = ({
  format = DATE_FORMAT,
  locale = DEFAULT_LOCALE,
  value,
  onChange,
  ...props
}) => {
  const [isCalendarOpened, setIsCalendarOpened] = useState(false);
  const calendarContainer = document.getElementById('calendar-container');
  const calendarContainerRef = useRef<HTMLDivElement>(null);
  const [bottomIndent, setBottomIndent] = useState(0);

  const handleOnChange = (val: Date) => {
    if (!val) {
      return;
    }

    onChange(val);
    setIsCalendarOpened(false);
  };

  useEffect(() => {
    const topIndent = calendarContainerRef.current?.getBoundingClientRect().top || 0;

    if (topIndent < 0) {
      setBottomIndent(topIndent);
    } else {
      setBottomIndent(0);
    }
  }, [isCalendarOpened]);

  useOuterClick(() => setIsCalendarOpened(false), calendarContainerRef);

  return (
    <DatePickerWrapperStyled>
      <CalendarContainerStyled
        ref={calendarContainerRef}
        isOpen={isCalendarOpened}
        bottomIndent={bottomIndent}
      >
        <div id="calendar-container"></div>

        <Button onClick={() => handleOnChange(new Date())}>
          <FormattedMessage id="common.today" defaultMessage="Today" />
        </Button>
      </CalendarContainerStyled>

      <DatePickerStyled
        value={value}
        format={format}
        clearIcon={null}
        onChange={val => handleOnChange(val as Date)}
        locale={locale}
        portalContainer={calendarContainer}
        onCalendarOpen={() => setIsCalendarOpened(true)}
        shouldCloseCalendar={() => !isCalendarOpened}
        isOpen={isCalendarOpened}
        {...props}
      />
    </DatePickerWrapperStyled>
  );
};

export default DatePickerField;
